import * as Sentry from '@sentry/browser'
import moment from 'moment'
import store from '../client/store'

const CMAP_MODE_B  = 1
const CMAP_MODE_C  = 2

export default {
  beforeMount() {
    Sentry.setTag('app_name', this.appName)
    Sentry.setTag('browse', window.location.pathname.indexOf('/admin') === 0 ? 'admin' : 'client')
    Sentry.setTag('debugger', window.debugClient ?? false)
  },
  computed: {
    isBtoC() {
      return this.appMode === CMAP_MODE_C
    },
    isBtoB() {
      return this.appMode !== CMAP_MODE_C
    },
    appName() {
      return document.getElementsByName('application-name')[0].content
    },
    appMode() {
      // ログインしている場合はユーザが属している企業のフラグを見て判断
      const isLoggedIn = store.getters['auth/isLoggedIn']
      if (isLoggedIn && store.state.auth.company) {
        return store.state.auth.company.is_consumer
          ? CMAP_MODE_C
          : CMAP_MODE_B
      }
      // 未ログインの場合はmetaタグで判断
      const appName = document.getElementsByName('application-name')[0].content
      return appName === process.env.MIX_APP_NAME_C
        ? CMAP_MODE_C
        : CMAP_MODE_B
    },
    isLaunched() {
      if (this.isBtoB || window.debugClient) {
        return true
      }
      const { MIX_LAUNCH_START } = process.env
      return MIX_LAUNCH_START
        ? moment(MIX_LAUNCH_START).isBefore()
        : true
    },
    isDebugClient() {
      return !!window.debugClient
    },
  },
  methods: {
    // scroll to top
    scrollToTop() {
      const scrollContainer = document.querySelector('.main-container')
      if (scrollContainer) {
        scrollContainer.scrollTop = 0
      }
    },
  },
}
